function Paginacao( _vm ) {

    this.vm = _vm;

    this.irPara = function (pagina) {

        if ((pagina == 'prev') && (this.vm.paginaAtual > 1)) {
            return this.vm.paginaAtual--;
        }

        if ((pagina == 'next') && (this.vm.paginaAtual < this.vm.ultimaPagina)) {
            return this.vm.paginaAtual++;
        }

        if ((pagina != 'prev') && (pagina != 'next')) {
            this.vm.paginaAtual = pagina;
        }
    };

    this.alteraPaginaAtual = function () {

        var valor = parseInt(this.vm.inputPagina);

        if( isNaN(valor) || (valor < 1) || (valor > this.vm.ultimaPagina) ){
            return this.vm.inputPagina = this.vm.paginaAtual;
        }

        this.vm.paginaAtual = this.vm.inputPagina;
    };
}